/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-empty-function */
/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2021-10-09 14:50:56
 * Copyright © Leedarson. All rights reserved.
 */
import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Menu = memo(({ width, children, onClick }) => {
  return (
    <div
      width={width}
      className="dropdown-menu lds-dropdown-menu"
      onClick={onClick}
    >
      {children}
    </div>
  );
});

Menu.defaultProps = {
  width: 'auto',
  children: null,
  onClick: () => {},
};

Menu.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default Menu;
